import React, { useState, useRef, useEffect } from "react";

import { cn } from "@/lib/helpers/cn";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { Popover } from "@/component-library";

const Select = (props) => {
  const { changeHandler, disabled, name, options, placeholder, testId, value } = props;
  const [state, setState] = useState({
    showDropdown: false,
  });

  useEffect(() => {
    if (
      document.querySelector(
        ".ScheduleEvent .Select__dropdown.d-block.opened, .EditEvent .Select__dropdown.d-block.opened",
      )
    ) {
      document
        .querySelector(
          ".ScheduleEvent .Select__dropdown.d-block.opened, .EditEvent .Select__dropdown.d-block.opened",
        )
        .scroll(0, 0);
    }
  }, []);

  let selectElRef = useRef(null);
  let preventBlur = false;
  // onMouseDown handler
  //mouseDownHandler is selected instead of click cox blur event is caused after mousedown but before click
  let customSelectHandler = (e) => {
    if (e.target.nodeName == "LI") {
      if (e.target.classList.contains("disabled-option")) {
        preventBlur = true;

        return;
      }

      let index = e.target.getAttribute("data-index");

      selectElRef.current.selectedIndex = index;
      let event = new Event("change", { bubbles: true });

      selectElRef.current.dispatchEvent(event);
      setState({
        showDropdown: false,
      });
    }
  };

  let toggleDropdownHandler = () => {
    setState((prevState) => {
      return {
        showDropdown: !prevState.showDropdown,
      };
    });
  };

  let dropDownBlurHandler = () => {
    if (!preventBlur) {
      setState({
        showDropdown: false,
      });
    }
    preventBlur = false;
  };
  /** To display on the button */
  let matchingElement =
    value === undefined ? placeholder : options.find((el) => el.value === value);
  let displayValue = matchingElement ? matchingElement.display : "";

  let selectWprClasses = ["Select__wpr", "d-flex", "flex-column"];

  /** styling the border of select wpr */
  if (disabled) {
    selectWprClasses.push("Select__wpr--disabled");
  }

  return (
    <div className={cn("Select", state.showDropdown && "opened")}>
      <div className={selectWprClasses.join(" ")}>
        <button
          className={cn(
            "Select__btn cursor d-flex align-items-center text-left",
            state.showDropdown && "opened",
          )}
          disabled={disabled}
          onBlur={dropDownBlurHandler}
          onClick={toggleDropdownHandler}
          type="button"
          {...getAutomationDataAttr(testId)}
        >
          <span>{displayValue}</span>
        </button>

        <div
          className={cn("Select__dropdown", state.showDropdown ? "d-block opened" : "d-none")}
          onMouseDown={customSelectHandler}
        >
          <ul className="m-0 p-0">
            {options.map((option, i) => {
              const automatedTestDataAttr = testId
                ? getAutomationDataAttr(`${testId}_option${i}`)
                : {};

              return (
                <React.Fragment key={option.value + i}>
                  <li
                    className={cn("px-3 py-1", option.disabled ? "disabled-option" : "cursor")}
                    data-for={option.toolTip?.id}
                    data-index={i}
                    data-tip={option.toolTip?.text}
                    {...automatedTestDataAttr}
                  >
                    {option.display}
                  </li>

                  {option.toolTip && (
                    <Popover
                      className="select-popover"
                      position="top"
                      toolTipId={option.toolTip?.id}
                    >
                      {option.toolTip?.text}
                    </Popover>
                  )}
                </React.Fragment>
              );
            })}
          </ul>
        </div>
      </div>

      <select name={name} onChange={changeHandler} ref={selectElRef} value={value}>
        {options.map((option, index) => {
          return (
            <option key={`${option.value}-${index}`} value={option.value}>
              {option.display}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default React.memo(Select);
